export default __webpack_public_path__ + "static/media/Pingoo-portfolio-capa.5303725c.jpg";